var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Packing Manager
 */
import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { message, Modal } from 'antd';
import { PrinterOutlined, ReloadOutlined, CaretDownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { usePackingState, usePackingActions, useLabelPrinting, useShipmentData, usePackageManagement, usePrinterConnection, useContainerActions } from '../../../hooks/packing';
import { selectSpsCartonLabel, selectShipmentData, selectPackageContentBySeqId } from '../../../redux/packing';
import { UpdateAddressModal, PackCompleteModal, SerialNumberModal, UpdatePackageModal, CancelShipmentModal, PrinterModal, ReturnLabelModal, } from '../modals';
import { PackingSubscreen } from '../types';
import { StatusBadge } from '../shared';
import { PackingManagerActions } from './PackingManagerActions';
import { BulkPackModal } from '../modals/BulkPackModal';
import { BulkContainerModal } from '../modals/BulkContainerModal';
import { PackingPane } from './PackingPane';
import { ScanToPackView } from './ScanToPackView';
import { ContainerPane } from './ContainerPane';
import { ClosePackageModal } from '../modals/ClosePackageModal';
import { CloseContainerModal } from '../modals/CloseContainerModal';
import { ShipmentAssemblyTaskPane } from './ShipmentAssemblyTaskPane';
import { LeftSidebar } from '../sidebar/LeftSidebar';
import { RightSidebar } from '../sidebar/RightSidebar';
export var PackingManager = function () {
    var _a;
    var t = useTranslation().t;
    var bulkPackModalRef = useRef(null);
    var bulkContainerModalRef = useRef(null);
    var _b = useState(null), selectedPackageRef = _b[0], setSelectedPackageRef = _b[1];
    var _c = useState(null), selectedContainerRef = _c[0], setSelectedContainerRef = _c[1];
    var _d = useState([]), virtualPackages = _d[0], setVirtualPackages = _d[1];
    var _e = useState([]), virtualContainers = _e[0], setVirtualContainers = _e[1];
    var _f = useState(null), pendingVirtualResolution = _f[0], setPendingVirtualResolution = _f[1];
    var _g = useState(false), isCloseModalVisible = _g[0], setIsCloseModalVisible = _g[1];
    var _h = useState(false), isAssemblyCollapsed = _h[0], setIsAssemblyCollapsed = _h[1];
    var _j = useState(false), resettingPackage = _j[0], setResettingPackage = _j[1];
    var _k = useState(false), bulkPackModalVisible = _k[0], setBulkPackModalVisible = _k[1];
    var _l = useState(false), bulkContainerModalVisible = _l[0], setBulkContainerModalVisible = _l[1];
    var _m = useState(0), scanInputFocusSignal = _m[0], setScanInputFocusSignal = _m[1];
    var _o = usePackingState(), shipmentId = _o.shipmentId, shipmentStatus = _o.shipmentStatus, shipmentStatusList = _o.shipmentStatusList, shipmentPackages = _o.shipmentPackages, packageRouteSegments = _o.packageRouteSegments, shipmentRouteSegments = _o.shipmentRouteSegments, loading = _o.loading, boxTypes = _o.boxTypes, productSkuUpcList = _o.productSkuUpcList, shipmentItemDetailList = _o.shipmentItemDetailList, packageOrderItemsBySeqId = _o.packageOrderItemsBySeqId, kitComponentProducts = _o.kitComponentProducts, packageSerialNumbersBySeqId = _o.packageSerialNumbersBySeqId, itemAssets = _o.itemAssets, destContactMechValid = _o.destContactMechValid, scanThroughPack = _o.scanThroughPack, navigateToSubscreen = _o.navigateToSubscreen, clearShipment = _o.clearShipment, loadShipmentDetails = _o.loadShipmentDetails;
    var _p = usePackingState(), shipmentContainerList = _p.shipmentContainerList, containerLinkedPackageSeqIds = _p.containerLinkedPackageSeqIds, containerTypeList = _p.containerTypeList;
    var _q = useContainerActions(), handleContainerScan = _q.handleContainerScan, handleBulkCreateContainers = _q.handleBulkCreateContainers, handleCreateContainer = _q.handleCreateContainer, handleBulkCloseContainers = _q.handleBulkCloseContainers, handleReopenContainer = _q.handleReopenContainer, handleDeleteContainer = _q.handleDeleteContainer, handleResetContainer = _q.handleResetContainer, handleResetAndReturnContainer = _q.handleResetAndReturnContainer, handleUpdateContainerType = _q.handleUpdateContainerType;
    var _r = usePackingActions(), handleScanProduct = _r.handleScanProduct, handleUnpackItem = _r.handleUnpackItem, handleDeletePackage = _r.handleDeletePackage, handleUpdateQuantity = _r.handleUpdateQuantity, handleCancelShipment = _r.handleCancelShipment, handleResetAllPackages = _r.handleResetAllPackages, handleDeleteAllPackages = _r.handleDeleteAllPackages, handleGetMainLabel = _r.handleGetMainLabel, handleRefundLabel = _r.handleRefundLabel;
    var findProductByIdOrSku = useShipmentData().findProductByIdOrSku;
    var _s = useLabelPrinting(), printPackingSlip = _s.printPackingSlip, printContainerInsert = _s.printContainerInsert, printMainLabel = _s.printMainLabel, printCartonLabel = _s.printCartonLabel, printReturnLabel = _s.printReturnLabel, getLabelUrl = _s.getLabelUrl, downloadLabel = _s.downloadLabel;
    var _t = usePackageManagement(), getPackageInfo = _t.getPackageInfo, resetPackage = _t.resetPackage;
    var isConnectionActive = usePrinterConnection().isConnectionActive;
    var confirm = Modal.confirm;
    var spsCartonLabel = useSelector(selectSpsCartonLabel);
    var shipmentData = useSelector(selectShipmentData);
    var packageContentBySeqId = useSelector(selectPackageContentBySeqId);
    var _u = useState(false), printerModalVisible = _u[0], setPrinterModalVisible = _u[1];
    var _v = useState(false), addressModalVisible = _v[0], setAddressModalVisible = _v[1];
    var _w = useState(false), packCompleteModalVisible = _w[0], setPackCompleteModalVisible = _w[1];
    var _x = useState(false), updatePackageModalVisible = _x[0], setUpdatePackageModalVisible = _x[1];
    var _y = useState(false), cancelModalVisible = _y[0], setCancelModalVisible = _y[1];
    var _z = useState(false), serialNumberModalVisible = _z[0], setSerialNumberModalVisible = _z[1];
    var _0 = useState(false), returnLabelModalVisible = _0[0], setReturnLabelModalVisible = _0[1];
    var _1 = useState(null), closeContainerModalContainerId = _1[0], setCloseContainerModalContainerId = _1[1];
    var _2 = useState(null), pendingScanId = _2[0], setPendingScanId = _2[1];
    var _3 = useState(null), pendingSerializedPackRequest = _3[0], setPendingSerializedPackRequest = _3[1];
    var statusDescription = useMemo(function () { var _a; return (_a = shipmentStatusList.find(function (status) { return status.statusId === shipmentStatus; })) === null || _a === void 0 ? void 0 : _a.description; }, [shipmentStatusList, shipmentStatus]);
    var containerTypeMap = useMemo(function () {
        var map = new Map();
        containerTypeList.forEach(function (ct) { return map.set(ct.enumId, ct.description); });
        return map;
    }, [containerTypeList]);
    var selectedPackageSeqId = (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'real' ? selectedPackageRef.seqId : null;
    var selectedPackageKey = selectedPackageRef
        ? selectedPackageRef.kind === 'real'
            ? "real:" + selectedPackageRef.seqId
            : "virtual:" + selectedPackageRef.tempId
        : null;
    var selectedContainerKey = selectedContainerRef
        ? selectedContainerRef.kind === 'real'
            ? "real:" + selectedContainerRef.containerId
            : "virtual:" + selectedContainerRef.tempId
        : null;
    // The real containerId for API calls (null if virtual or nothing selected)
    var selectedRealContainerId = (selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.kind) === 'real' ? selectedContainerRef.containerId : null;
    // The linked package seqId for the currently selected container (if closed)
    var activeContainerLinkedSeqId = useMemo(function () {
        var _a;
        if (!selectedRealContainerId)
            return null;
        var container = shipmentContainerList.find(function (c) { return c.containerId === selectedRealContainerId; });
        return (_a = container === null || container === void 0 ? void 0 : container.shipmentPackageSeqId) !== null && _a !== void 0 ? _a : null;
    }, [selectedRealContainerId, shipmentContainerList]);
    var selectedVirtualPackage = (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'virtual'
        ? virtualPackages.find(function (pkg) { return pkg.tempId === selectedPackageRef.tempId; })
        : undefined;
    var selectedPackageInfo = selectedPackageSeqId ? getPackageInfo(selectedPackageSeqId) : null;
    var selectedPackageRouteSegment = useMemo(function () {
        return selectedPackageSeqId
            ? packageRouteSegments.find(function (item) { return item.shipmentPackageSeqId === selectedPackageSeqId; }) ||
                null
            : null;
    }, [packageRouteSegments, selectedPackageSeqId]);
    var selectedPackageHasContents = useMemo(function () {
        return selectedPackageSeqId
            ? (packageContentBySeqId[selectedPackageSeqId] || []).length > 0
            : false;
    }, [packageContentBySeqId, selectedPackageSeqId]);
    var packageSeqIdsWithContent = useMemo(function () {
        return Object.entries(packageContentBySeqId)
            .filter(function (_a) {
            var contents = _a[1];
            return Array.isArray(contents) && contents.length > 0;
        })
            .map(function (_a) {
            var seqId = _a[0];
            return seqId;
        });
    }, [packageContentBySeqId]);
    var showResetAllPackages = useMemo(function () {
        if (!(packageRouteSegments === null || packageRouteSegments === void 0 ? void 0 : packageRouteSegments.length))
            return false;
        return packageSeqIdsWithContent.some(function (packageSeqId) {
            var packageRouteSegment = packageRouteSegments.find(function (item) { return item.shipmentPackageSeqId === packageSeqId; });
            return !(packageRouteSegment === null || packageRouteSegment === void 0 ? void 0 : packageRouteSegment.trackingCode);
        });
    }, [packageRouteSegments, packageSeqIdsWithContent]);
    var showDeleteAllPackages = ((packageRouteSegments === null || packageRouteSegments === void 0 ? void 0 : packageRouteSegments.length) || 0) > 0 && packageSeqIdsWithContent.length === 0;
    var showAssemblyTaskPane = useMemo(function () { return (kitComponentProducts || []).some(function (item) { return (item === null || item === void 0 ? void 0 : item.totalQuantity) > 0; }); }, [kitComponentProducts]);
    useEffect(function () {
        if (!showAssemblyTaskPane) {
            setIsAssemblyCollapsed(false);
        }
    }, [showAssemblyTaskPane]);
    var materializeVirtualPackage = useCallback(function (tempId, shipmentPackageSeqId) {
        if (!shipmentPackageSeqId)
            return;
        setVirtualPackages(function (prev) { return prev.filter(function (pkg) { return pkg.tempId !== tempId; }); });
        setSelectedPackageRef(function (prev) {
            if ((prev === null || prev === void 0 ? void 0 : prev.kind) === 'virtual' && prev.tempId === tempId) {
                return { kind: 'real', seqId: shipmentPackageSeqId };
            }
            return prev;
        });
        setIsCloseModalVisible(false);
    }, []);
    var resolveShipmentPackageSeqIdFromScanResult = useCallback(function (scanResult) {
        if (!scanResult || typeof scanResult !== 'object') {
            return null;
        }
        var directSeqId = scanResult.shipmentPackageSeqId;
        if (typeof directSeqId === 'string' && directSeqId.trim()) {
            return directSeqId;
        }
        var packResult = scanResult.packResult;
        if (!packResult || typeof packResult !== 'object') {
            return null;
        }
        if (typeof packResult.shipmentPackageSeqId === 'string' &&
            packResult.shipmentPackageSeqId.trim()) {
            return packResult.shipmentPackageSeqId;
        }
        var shipmentPackage = packResult.shipmentPackage;
        if (shipmentPackage &&
            typeof shipmentPackage.shipmentPackageSeqId === 'string' &&
            shipmentPackage.shipmentPackageSeqId.trim()) {
            return shipmentPackage.shipmentPackageSeqId;
        }
        return null;
    }, []);
    var isSerializedScanId = useCallback(function (scanId) {
        if (!scanId)
            return false;
        var normalizedScanId = scanId.trim().toLowerCase();
        if (!normalizedScanId)
            return false;
        var matchedProduct = findProductByIdOrSku(scanId);
        if ((matchedProduct === null || matchedProduct === void 0 ? void 0 : matchedProduct.serialized) === 'Y') {
            return true;
        }
        var matchedByNormalizedSku = productSkuUpcList.find(function (item) {
            return [item.productId, item.productSku, item.productUpc]
                .filter(Boolean)
                .some(function (value) { return String(value).trim().toLowerCase() === normalizedScanId; });
        });
        if ((matchedByNormalizedSku === null || matchedByNormalizedSku === void 0 ? void 0 : matchedByNormalizedSku.serialized) === 'Y') {
            return true;
        }
        return (shipmentItemDetailList || []).some(function (item) {
            if ((item === null || item === void 0 ? void 0 : item.serialized) !== 'Y')
                return false;
            return [item.productId, item.pseudoId]
                .filter(Boolean)
                .some(function (value) { return String(value).trim().toLowerCase() === normalizedScanId; });
        });
    }, [findProductByIdOrSku, productSkuUpcList, shipmentItemDetailList]);
    useEffect(function () {
        var _a;
        if (!pendingVirtualResolution)
            return;
        var beforeSeqIds = new Set(pendingVirtualResolution.beforePackageSeqIds);
        var createdPackageSeqId = ((_a = shipmentPackages
            .map(function (shipmentPackage, index) { return ({ shipmentPackage: shipmentPackage, index: index }); })
            .filter(function (_a) {
            var shipmentPackage = _a.shipmentPackage;
            return !beforeSeqIds.has(shipmentPackage.shipmentPackageSeqId);
        })
            .reduce(function (selected, candidate) {
            if (!selected)
                return candidate;
            var selectedCreatedAt = Date.parse(selected.shipmentPackage.dateCreated || '');
            var candidateCreatedAt = Date.parse(candidate.shipmentPackage.dateCreated || '');
            var selectedHasCreatedAt = Number.isFinite(selectedCreatedAt);
            var candidateHasCreatedAt = Number.isFinite(candidateCreatedAt);
            if (selectedHasCreatedAt && candidateHasCreatedAt && selectedCreatedAt !== candidateCreatedAt) {
                return candidateCreatedAt > selectedCreatedAt ? candidate : selected;
            }
            var selectedSeqIdNumber = Number(selected.shipmentPackage.shipmentPackageSeqId);
            var candidateSeqIdNumber = Number(candidate.shipmentPackage.shipmentPackageSeqId);
            var selectedHasNumericSeqId = Number.isFinite(selectedSeqIdNumber);
            var candidateHasNumericSeqId = Number.isFinite(candidateSeqIdNumber);
            if (selectedHasNumericSeqId &&
                candidateHasNumericSeqId &&
                selectedSeqIdNumber !== candidateSeqIdNumber) {
                return candidateSeqIdNumber > selectedSeqIdNumber ? candidate : selected;
            }
            return candidate.index > selected.index ? candidate : selected;
        }, null)) === null || _a === void 0 ? void 0 : _a.shipmentPackage.shipmentPackageSeqId) || null;
        if (createdPackageSeqId) {
            materializeVirtualPackage(pendingVirtualResolution.tempId, createdPackageSeqId);
            setPendingVirtualResolution(null);
        }
    }, [materializeVirtualPackage, pendingVirtualResolution, shipmentPackages]);
    useEffect(function () {
        if ((selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return;
        var stillExists = shipmentPackages.some(function (shipmentPackage) { return shipmentPackage.shipmentPackageSeqId === selectedPackageRef.seqId; });
        if (!stillExists) {
            setSelectedPackageRef(null);
            setIsCloseModalVisible(false);
            setUpdatePackageModalVisible(false);
        }
    }, [selectedPackageRef, shipmentPackages]);
    var handleBack = useCallback(function () {
        clearShipment();
        setSelectedPackageRef(null);
        setVirtualPackages([]);
        setPendingVirtualResolution(null);
        setPendingSerializedPackRequest(null);
        setPendingScanId(null);
        setSerialNumberModalVisible(false);
        setUpdatePackageModalVisible(false);
        setBulkPackModalVisible(false);
        setIsCloseModalVisible(false);
        setReturnLabelModalVisible(false);
        if (scanThroughPack) {
            navigateToSubscreen(PackingSubscreen.ShipmentList);
        }
        else {
            navigateToSubscreen(PackingSubscreen.ShipmentId);
        }
    }, [clearShipment, navigateToSubscreen, scanThroughPack]);
    var handleNewPackage = useCallback(function (boxTypeId) {
        var tempId = "virtual-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8);
        setVirtualPackages(function (prev) {
            var maxRealPackageNumber = shipmentPackages.reduce(function (maxNumber, shipmentPackage) {
                var packageNumber = Number(shipmentPackage.shipmentPackageSeqId);
                if (Number.isFinite(packageNumber) && packageNumber > maxNumber) {
                    return packageNumber;
                }
                return maxNumber;
            }, 0);
            var maxVirtualPackageNumber = prev.reduce(function (maxNumber, virtualPackage) {
                if (virtualPackage.displayPackageNumber > maxNumber) {
                    return virtualPackage.displayPackageNumber;
                }
                return maxNumber;
            }, 0);
            var nextDisplayPackageNumber = Math.max(maxRealPackageNumber, maxVirtualPackageNumber) + 1;
            return __spreadArray(__spreadArray([], prev, true), [
                __assign({ tempId: tempId, displayPackageNumber: nextDisplayPackageNumber }, (boxTypeId ? { shipmentBoxTypeId: boxTypeId } : {}))
            ], false);
        });
        setSelectedPackageRef({ kind: 'virtual', tempId: tempId });
        setPendingVirtualResolution(null);
        setIsCloseModalVisible(false);
        setScanInputFocusSignal(function (prev) { return prev + 1; });
    }, [shipmentPackages]);
    var handleSidebarPackageSelect = useCallback(function (packageRef, _pkgIsClosed) {
        var isSameSelection = !!selectedPackageRef &&
            ((packageRef.kind === 'real' &&
                selectedPackageRef.kind === 'real' &&
                selectedPackageRef.seqId === packageRef.seqId) ||
                (packageRef.kind === 'virtual' &&
                    selectedPackageRef.kind === 'virtual' &&
                    selectedPackageRef.tempId === packageRef.tempId));
        if (isSameSelection) {
            setSelectedPackageRef(null);
            setIsCloseModalVisible(false);
            setUpdatePackageModalVisible(false);
            return;
        }
        setSelectedPackageRef(packageRef);
        setSelectedContainerRef(null);
        setPendingVirtualResolution(null);
        setPendingSerializedPackRequest(null);
        setPendingScanId(null);
        setSerialNumberModalVisible(false);
        setIsCloseModalVisible(false);
        setUpdatePackageModalVisible(false);
        setScanInputFocusSignal(function (prev) { return prev + 1; });
    }, [selectedPackageRef]);
    var handleSidebarContainerSelect = useCallback(function (containerRef) {
        var isSameSelection = selectedContainerRef &&
            containerRef.kind === selectedContainerRef.kind &&
            (containerRef.kind === 'real'
                ? containerRef.containerId === selectedContainerRef.containerId
                : containerRef.tempId === selectedContainerRef.tempId);
        if (isSameSelection) {
            setSelectedContainerRef(null);
        }
        else {
            setSelectedContainerRef(containerRef);
            setSelectedPackageRef(null);
        }
    }, [selectedContainerRef]);
    var handlePaneContainerSelect = useCallback(function (containerId) {
        setSelectedContainerRef(function (previousSelection) {
            if ((previousSelection === null || previousSelection === void 0 ? void 0 : previousSelection.kind) === 'real' &&
                previousSelection.containerId === containerId) {
                return previousSelection;
            }
            return { kind: 'real', containerId: containerId };
        });
        setSelectedPackageRef(null);
    }, []);
    var handlePackForSelectedPackage = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedPackageAtSubmit, beforePackageSeqIds, scanResult, resolvedPackageSeqId, resolvedPackageSeqId, tempId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedPackageAtSubmit = selectedPackageRef;
                    beforePackageSeqIds = shipmentPackages.map(function (pkg) { return pkg.shipmentPackageSeqId; });
                    return [4 /*yield*/, handleScanProduct({
                            scanId: params.scanId,
                            shipmentItemDetailList: shipmentItemDetailList || [],
                            kitComponentProducts: kitComponentProducts || [],
                            quantity: params.quantity,
                            carton: params.carton,
                            serialNumber: params.serialNumber,
                            shipmentPackageSeqId: params.shipmentPackageSeqId,
                            shipmentBoxTypeId: params.shipmentBoxTypeId
                        })];
                case 1:
                    scanResult = _a.sent();
                    if ((selectedPackageAtSubmit === null || selectedPackageAtSubmit === void 0 ? void 0 : selectedPackageAtSubmit.kind) === 'virtual') {
                        resolvedPackageSeqId = resolveShipmentPackageSeqIdFromScanResult(scanResult);
                        if (resolvedPackageSeqId) {
                            materializeVirtualPackage(selectedPackageAtSubmit.tempId, resolvedPackageSeqId);
                            setPendingVirtualResolution(null);
                        }
                        else {
                            setPendingVirtualResolution({
                                tempId: selectedPackageAtSubmit.tempId,
                                beforePackageSeqIds: beforePackageSeqIds
                            });
                        }
                    }
                    else if (!selectedPackageAtSubmit) {
                        resolvedPackageSeqId = resolveShipmentPackageSeqIdFromScanResult(scanResult);
                        if (resolvedPackageSeqId) {
                            setSelectedPackageRef({ kind: 'real', seqId: resolvedPackageSeqId });
                        }
                        else {
                            tempId = "virtual-scan-" + Date.now();
                            setSelectedPackageRef({ kind: 'virtual', tempId: tempId });
                            setPendingVirtualResolution({
                                tempId: tempId,
                                beforePackageSeqIds: beforePackageSeqIds
                            });
                        }
                    }
                    return [2 /*return*/, scanResult];
            }
        });
    }); }, [
        selectedPackageRef,
        shipmentPackages,
        handleScanProduct,
        shipmentItemDetailList,
        kitComponentProducts,
        resolveShipmentPackageSeqIdFromScanResult,
        materializeVirtualPackage
    ]);
    var handlePackRequest = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            if (!params.serialNumber && isSerializedScanId(params.scanId)) {
                setPendingScanId(params.scanId);
                setPendingSerializedPackRequest({
                    scanId: params.scanId,
                    quantity: params.quantity,
                    carton: params.carton,
                    shipmentPackageSeqId: (_b = (_a = params.shipmentPackageSeqId) !== null && _a !== void 0 ? _a : selectedPackageSeqId) !== null && _b !== void 0 ? _b : undefined,
                    shipmentBoxTypeId: (_c = params.shipmentBoxTypeId) !== null && _c !== void 0 ? _c : selectedVirtualPackage === null || selectedVirtualPackage === void 0 ? void 0 : selectedVirtualPackage.shipmentBoxTypeId
                });
                setSerialNumberModalVisible(true);
                return [2 /*return*/, { deferredSerialPrompt: true }];
            }
            return [2 /*return*/, handlePackForSelectedPackage(params)];
        });
    }); }, [isSerializedScanId, selectedPackageSeqId, selectedVirtualPackage, handlePackForSelectedPackage]);
    var handleAdvanceToClose = useCallback(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real' || (selectedPackageInfo === null || selectedPackageInfo === void 0 ? void 0 : selectedPackageInfo.isClosed)) {
            return;
        }
        setIsCloseModalVisible(true);
    }, [selectedPackageInfo, selectedPackageRef, selectedPackageSeqId]);
    var handlePackageClosed = useCallback(function () {
        setIsCloseModalVisible(false);
    }, []);
    var handleOpenUpdatePackage = useCallback(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return;
        setUpdatePackageModalVisible(true);
    }, [selectedPackageRef, selectedPackageSeqId]);
    var handleScannerDelete = useCallback(function () {
        setSelectedPackageRef(function (prev) {
            if ((prev === null || prev === void 0 ? void 0 : prev.kind) === 'virtual') {
                setVirtualPackages(function (virtuals) { return virtuals.filter(function (pkg) { return pkg.tempId !== prev.tempId; }); });
            }
            return null;
        });
        setPendingVirtualResolution(null);
        setPendingSerializedPackRequest(null);
        setPendingScanId(null);
        setSerialNumberModalVisible(false);
        setIsCloseModalVisible(false);
        setUpdatePackageModalVisible(false);
        setReturnLabelModalVisible(false);
    }, []);
    var handleConfirmCancel = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleCancelShipment()];
                case 1:
                    _a.sent();
                    clearShipment();
                    setSelectedPackageRef(null);
                    setVirtualPackages([]);
                    setPendingVirtualResolution(null);
                    setPendingSerializedPackRequest(null);
                    setPendingScanId(null);
                    setSerialNumberModalVisible(false);
                    setUpdatePackageModalVisible(false);
                    setBulkPackModalVisible(false);
                    setIsCloseModalVisible(false);
                    setReturnLabelModalVisible(false);
                    navigateToSubscreen(PackingSubscreen.ShipmentId);
                    return [2 /*return*/];
            }
        });
    }); }, [handleCancelShipment, clearShipment, navigateToSubscreen]);
    var handleResetPackage = useCallback(function (seqId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setResettingPackage(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, resetPackage(seqId)];
                case 2:
                    _b.sent();
                    message.success(t('Package has been reopened for scanning'));
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    message.error(t('Failed to reset package'));
                    return [3 /*break*/, 5];
                case 4:
                    setResettingPackage(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [resetPackage, t]);
    var handleResetAllPackagesAction = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleResetAllPackages()];
                case 1:
                    _a.sent();
                    setIsCloseModalVisible(false);
                    return [2 /*return*/];
            }
        });
    }); }, [handleResetAllPackages]);
    var handleDeleteAllPackagesAction = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleDeleteAllPackages()];
                case 1:
                    _a.sent();
                    setSelectedPackageRef(null);
                    setVirtualPackages([]);
                    setPendingVirtualResolution(null);
                    setPendingSerializedPackRequest(null);
                    setPendingScanId(null);
                    setSerialNumberModalVisible(false);
                    setUpdatePackageModalVisible(false);
                    setBulkPackModalVisible(false);
                    setIsCloseModalVisible(false);
                    setReturnLabelModalVisible(false);
                    return [2 /*return*/];
            }
        });
    }); }, [handleDeleteAllPackages]);
    var canGetMainLabel = useMemo(function () {
        var routeSegment = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0];
        var hasShippingGatewayConfig = Boolean((shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shippingGatewayConfigId) || (routeSegment === null || routeSegment === void 0 ? void 0 : routeSegment.shippingGatewayConfigId));
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return (!(selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.trackingCode) &&
            !(selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.gatewayLabelId) &&
            !!(selectedPackageInfo === null || selectedPackageInfo === void 0 ? void 0 : selectedPackageInfo.shipmentBoxTypeId) &&
            hasShippingGatewayConfig);
    }, [
        selectedPackageInfo,
        selectedPackageRef,
        selectedPackageRouteSegment,
        selectedPackageSeqId,
        shipmentData,
        shipmentRouteSegments
    ]);
    var canDownloadMainLabel = useMemo(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return Boolean((selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.gatewayLabelId) ||
            (selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.labelImage) ||
            (selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.labelUrl));
    }, [selectedPackageRef, selectedPackageRouteSegment, selectedPackageSeqId]);
    var canRequestReturnLabel = useMemo(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return Boolean((selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.trackingCode) && !(selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.returnTrackingCode));
    }, [selectedPackageRef, selectedPackageRouteSegment, selectedPackageSeqId]);
    var canUseReturnLabel = useMemo(function () {
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return Boolean(selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.returnTrackingCode);
    }, [selectedPackageRef, selectedPackageRouteSegment, selectedPackageSeqId]);
    var canRefundLabel = useMemo(function () {
        var _a;
        if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
            return false;
        return Boolean((selectedPackageRouteSegment === null || selectedPackageRouteSegment === void 0 ? void 0 : selectedPackageRouteSegment.trackingCode) && ((_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.carrierPartyId));
    }, [selectedPackageRef, selectedPackageRouteSegment, selectedPackageSeqId, shipmentRouteSegments]);
    var handleGetMainLabelForSelectedPackage = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var shipmentRouteSegmentSeqId, fetchMainLabel;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectedPackageSeqId)
                        return [2 /*return*/];
                    shipmentRouteSegmentSeqId = (_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shipmentRouteSegmentSeqId;
                    if (!shipmentRouteSegmentSeqId) {
                        message.error(t('Something went wrong'));
                        return [2 /*return*/];
                    }
                    fetchMainLabel = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleGetMainLabel({
                                        shipmentPackageSeqId: selectedPackageSeqId,
                                        shipmentRouteSegmentSeqId: shipmentRouteSegmentSeqId
                                    })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    if (!selectedPackageHasContents) {
                        message.error(t('Something went wrong'));
                        return [2 /*return*/];
                    }
                    if (!destContactMechValid) {
                        confirm({
                            title: 'Warning: destination address is incomplete or invalid according to address validation',
                            icon: _jsx(ExclamationCircleOutlined, {}, void 0),
                            onOk: fetchMainLabel,
                            onCancel: function () { },
                            okText: t('Get Label Anyway')
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetchMainLabel()];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [
        confirm,
        destContactMechValid,
        handleGetMainLabel,
        selectedPackageHasContents,
        selectedPackageSeqId,
        shipmentRouteSegments,
        t
    ]);
    var handleDownloadMainLabel = useCallback(function () {
        var _a;
        if (!shipmentId || !selectedPackageSeqId)
            return;
        var shipmentRouteSegmentSeqId = (_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shipmentRouteSegmentSeqId;
        if (!shipmentRouteSegmentSeqId)
            return;
        var url = process.env.REACT_APP_API_BASE_URL + "/rest/s1/handheld/pack/shipment/" + shipmentId + "/label?shipmentRouteSegmentSeqId=" + shipmentRouteSegmentSeqId + "&shipmentPackageSeqId=" + selectedPackageSeqId;
        window.open(url, '_blank');
    }, [shipmentId, selectedPackageSeqId, shipmentRouteSegments]);
    var handleOpenReturnLabelModal = useCallback(function () {
        if (!selectedPackageSeqId)
            return;
        setReturnLabelModalVisible(true);
    }, [selectedPackageSeqId]);
    var handleDownloadReturnLabel = useCallback(function () {
        var _a;
        if (!shipmentId || !selectedPackageSeqId)
            return;
        var shipmentRouteSegmentSeqId = (_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shipmentRouteSegmentSeqId;
        if (!shipmentRouteSegmentSeqId)
            return;
        var url = process.env.REACT_APP_API_BASE_URL + "/rest/s1/handheld/pack/shipment/" + shipmentId + "/label?shipmentRouteSegmentSeqId=" + shipmentRouteSegmentSeqId + "&shipmentPackageSeqId=" + selectedPackageSeqId + "&retLabel=true";
        window.open(url, '_blank');
    }, [shipmentId, selectedPackageSeqId, shipmentRouteSegments]);
    var handlePrintReturnLabel = useCallback(function () {
        if (!selectedPackageSeqId)
            return;
        void printReturnLabel(selectedPackageSeqId);
    }, [printReturnLabel, selectedPackageSeqId]);
    var handleRefundLabelForSelectedPackage = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedRouteSegment, carrierPartyId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedPackageSeqId)
                        return [2 /*return*/];
                    selectedRouteSegment = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0];
                    carrierPartyId = selectedRouteSegment === null || selectedRouteSegment === void 0 ? void 0 : selectedRouteSegment.carrierPartyId;
                    if (!carrierPartyId)
                        return [2 /*return*/];
                    return [4 /*yield*/, handleRefundLabel({
                            shipmentPackageSeqId: selectedPackageSeqId,
                            carrierPartyId: carrierPartyId,
                            shippingGatewayConfigId: selectedRouteSegment === null || selectedRouteSegment === void 0 ? void 0 : selectedRouteSegment.shippingGatewayConfigId
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handleRefundLabel, selectedPackageSeqId, shipmentRouteSegments]);
    var handleSerialNumberSubmit = useCallback(function (serialNumber) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pendingSerializedPackRequest)
                        return [2 /*return*/];
                    return [4 /*yield*/, handlePackForSelectedPackage({
                            scanId: pendingSerializedPackRequest.scanId,
                            quantity: pendingSerializedPackRequest.quantity,
                            carton: pendingSerializedPackRequest.carton,
                            serialNumber: serialNumber,
                            shipmentPackageSeqId: pendingSerializedPackRequest.shipmentPackageSeqId,
                            shipmentBoxTypeId: pendingSerializedPackRequest.shipmentBoxTypeId
                        })];
                case 1:
                    _a.sent();
                    setSerialNumberModalVisible(false);
                    setPendingSerializedPackRequest(null);
                    setPendingScanId(null);
                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                    return [2 /*return*/];
            }
        });
    }); }, [pendingSerializedPackRequest, handlePackForSelectedPackage]);
    var productStoreId = (_a = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipment) === null || _a === void 0 ? void 0 : _a.productStoreId;
    var packerName = useMemo(function () { return localStorage.getItem('loggedInUserName') || '-'; }, []);
    var isRefreshingShipment = loading.shipment;
    var handleRefreshShipment = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId || isRefreshingShipment)
                        return [2 /*return*/];
                    return [4 /*yield*/, loadShipmentDetails(shipmentId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [shipmentId, isRefreshingShipment, loadShipmentDetails]);
    var handleBulkPackSubmit = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var bulkPackResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleBulkCreateContainers({
                        scanInput: params.scanId,
                        numberOfContainers: params.carton,
                        quantityPerContainer: params.quantity,
                        containerTypeEnumId: 'CtCarton'
                    })];
                case 1:
                    bulkPackResult = _a.sent();
                    if (!(bulkPackResult === null || bulkPackResult === void 0 ? void 0 : bulkPackResult.containerIdList)) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleBulkCloseContainers({
                            containerIds: bulkPackResult.containerIdList,
                            shipmentBoxTypeId: params.shipmentBoxTypeId,
                            weight: params.weight,
                            weightUomId: 'WT_lb',
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    setBulkPackModalVisible(false);
                    setSelectedPackageRef(null);
                    setPendingVirtualResolution(null);
                    setIsCloseModalVisible(false);
                    setUpdatePackageModalVisible(false);
                    return [2 /*return*/];
            }
        });
    }); }, [handleBulkCreateContainers, handleBulkCloseContainers]);
    var handleScanToPack = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var prefillData, packIntoContainerId, parentContainerId, containerTypeEnumId, vc, result, _a, containerTypeEnumId, result, _b, packResult;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    // route to bulk packing dialogs with inputs
                    if (params.quantityMode === 'bulk') {
                        prefillData = { scanId: params.scanId, quantity: params.quantity };
                        if (params.scanMode === 'carton') {
                            (_c = bulkPackModalRef.current) === null || _c === void 0 ? void 0 : _c.prefill(prefillData);
                            setBulkPackModalVisible(true);
                        }
                        else if (params.scanMode === 'pallet') {
                            (_d = bulkContainerModalRef.current) === null || _d === void 0 ? void 0 : _d.prefill(prefillData);
                            setBulkContainerModalVisible(true);
                        }
                        return [2 /*return*/];
                    }
                    if (!selectedContainerRef) return [3 /*break*/, 4];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    packIntoContainerId = void 0;
                    parentContainerId = void 0;
                    containerTypeEnumId = void 0;
                    if (selectedContainerRef.kind === 'real') {
                        packIntoContainerId = selectedContainerRef.containerId;
                    }
                    else {
                        vc = virtualContainers.find(function (v) { return v.tempId === selectedContainerRef.tempId; });
                        if (vc === null || vc === void 0 ? void 0 : vc.parentContainerId) {
                            parentContainerId = vc.parentContainerId;
                        }
                        containerTypeEnumId = vc === null || vc === void 0 ? void 0 : vc.containerTypeEnumId;
                        // else: virtual root — both stay undefined → creates new root
                    }
                    return [4 /*yield*/, handleContainerScan({
                            scanInput: params.scanId,
                            quantity: params.quantity,
                            packIntoContainerId: packIntoContainerId,
                            parentContainerId: parentContainerId,
                            containerTypeEnumId: containerTypeEnumId
                        })
                        // Materialize virtual container: backend returns the real containerId
                    ];
                case 2:
                    result = _e.sent();
                    // Materialize virtual container: backend returns the real containerId
                    if (selectedContainerRef.kind === 'virtual' && (result === null || result === void 0 ? void 0 : result.containerId)) {
                        setVirtualContainers(function (prev) {
                            return prev.filter(function (vc) { return vc.tempId !== selectedContainerRef.tempId; });
                        });
                        setSelectedContainerRef({ kind: 'real', containerId: result.containerId });
                    }
                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                    return [2 /*return*/, result];
                case 3:
                    _a = _e.sent();
                    return [2 /*return*/, undefined];
                case 4:
                    if (!(params.scanMode && ['carton', 'pallet'].includes(params.scanMode) && !selectedPackageRef)) return [3 /*break*/, 8];
                    _e.label = 5;
                case 5:
                    _e.trys.push([5, 7, , 8]);
                    containerTypeEnumId = params.scanMode === 'pallet' ? 'CtPallet' : 'CtCarton';
                    return [4 /*yield*/, handleContainerScan({
                            scanInput: params.scanId,
                            quantity: params.quantity,
                            containerTypeEnumId: containerTypeEnumId
                        })
                        // Select the newly created container
                    ];
                case 6:
                    result = _e.sent();
                    // Select the newly created container
                    if (result === null || result === void 0 ? void 0 : result.containerId) {
                        setSelectedContainerRef({ kind: 'real', containerId: result.containerId });
                        setSelectedPackageRef(null);
                    }
                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                    return [2 /*return*/, result];
                case 7:
                    _b = _e.sent();
                    return [2 /*return*/, undefined];
                case 8: return [4 /*yield*/, handlePackRequest({
                        scanId: params.scanId,
                        quantity: params.quantity,
                        shipmentPackageSeqId: (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'real' ? selectedPackageRef.seqId : undefined,
                        shipmentBoxTypeId: (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'virtual'
                            ? selectedVirtualPackage === null || selectedVirtualPackage === void 0 ? void 0 : selectedVirtualPackage.shipmentBoxTypeId
                            : undefined
                    })];
                case 9:
                    packResult = _e.sent();
                    if (!(packResult && 'deferredSerialPrompt' in packResult && packResult.deferredSerialPrompt)) {
                        setScanInputFocusSignal(function (prev) { return prev + 1; });
                    }
                    return [2 /*return*/, packResult];
            }
        });
    }); }, [selectedPackageRef, selectedVirtualPackage, handlePackRequest, selectedContainerRef, handleContainerScan, virtualContainers,]);
    var handleBulkPackIntoContainer = function (containerId) {
        setSelectedContainerRef({ kind: 'real', containerId: containerId });
        setBulkContainerModalVisible(true);
    };
    var handleUnpackPackageItem = useCallback(function (assetIssuanceId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleUnpackItem(assetIssuanceId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handleUnpackItem]);
    var handleUpdatePackageItemQuantity = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedPackageSeqId || (selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) !== 'real')
                        return [2 /*return*/];
                    return [4 /*yield*/, handleUpdateQuantity({
                            shipmentPackageSeqId: selectedPackageSeqId,
                            productId: params.productId,
                            quantity: params.quantity,
                            orderId: params.orderId,
                            orderItemSeqId: params.orderItemSeqId
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handleUpdateQuantity, selectedPackageRef, selectedPackageSeqId]);
    var handleDeleteSelectedPackage = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectedPackageRef)
                        return [2 /*return*/];
                    if (selectedPackageRef.kind === 'virtual') {
                        handleScannerDelete();
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleDeletePackage(selectedPackageRef.seqId)];
                case 2:
                    _b.sent();
                    setSelectedPackageRef(null);
                    setIsCloseModalVisible(false);
                    setUpdatePackageModalVisible(false);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    message.error(t('Failed to delete package'));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [selectedPackageRef, handleScannerDelete, handleDeletePackage, t]);
    var handleResetSelectedPackage = useCallback(function () {
        if (!selectedPackageSeqId)
            return;
        void handleResetPackage(selectedPackageSeqId);
    }, [selectedPackageSeqId, handleResetPackage]);
    var handleDeleteSelectedPackageAction = useCallback(function () {
        void handleDeleteSelectedPackage();
    }, [handleDeleteSelectedPackage]);
    return (_jsxs("div", __assign({ className: 'flex h-full min-h-0 flex-col bg-gray-100 text-gray-800' }, { children: [_jsxs("header", __assign({ className: 'flex h-16 shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4 shadow-sm sm:px-6' }, { children: [_jsxs("div", __assign({ className: 'flex items-center gap-2 sm:gap-3 pl-8' }, { children: [_jsxs("button", __assign({ onClick: handleBack, className: 'flex items-center text-gray-500 transition-colors hover:text-primary' }, { children: [_jsx(MdOutlineKeyboardBackspace, { style: { fontSize: '22px' } }, void 0), _jsx("span", __assign({ className: 'text-xs font-semibold sm:text-sm' }, { children: t('GO BACK') }), void 0)] }), void 0), _jsx("div", { className: 'mx-2 hidden h-6 w-px bg-gray-300 sm:block' }, void 0), _jsxs("h2", __assign({ className: 'text-sm font-bold text-gray-800 sm:text-lg' }, { children: [t('Pack Shipment'), " #", shipmentId] }), void 0), shipmentStatus && (_jsx("div", __assign({ className: 'hidden items-center gap-2 sm:flex' }, { children: _jsx(StatusBadge, { status: shipmentStatus, statusDescription: statusDescription }, void 0) }), void 0))] }), void 0), _jsxs("div", __assign({ className: 'flex items-center gap-3' }, { children: [_jsxs("span", __assign({ className: 'hidden text-xs text-gray-500 lg:block capitalize' }, { children: [t('Packer'), ": ", _jsx("strong", { children: packerName }, void 0)] }), void 0), _jsx("button", __assign({ onClick: function () {
                                    void handleRefreshShipment();
                                }, disabled: !shipmentId || isRefreshingShipment, className: 'flex items-center justify-center rounded-lg border border-gray-200 bg-white p-2 text-gray-500 leading-none transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60 sm:px-4', title: t('Reload Shipment') }, { children: _jsx(ReloadOutlined, { spin: isRefreshingShipment, style: { fontSize: '14px' } }, void 0) }), void 0), _jsx("button", __assign({ onClick: function () { return setPrinterModalVisible(true); }, className: "flex items-center gap-2 rounded-lg border px-3 py-2 transition-colors sm:px-4 " + (isConnectionActive
                                    ? 'border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100'
                                    : 'border-gray-200 bg-white text-gray-500 hover:bg-gray-50'), title: (isConnectionActive ? t('Printer Connected') : t('Printer Disconnected')) }, { children: _jsx(PrinterOutlined, { style: { fontSize: '16px' }, className: 'self-center' }, void 0) }), void 0)] }), void 0)] }), void 0), _jsx("main", __assign({ className: 'flex-1 overflow-hidden p-4' }, { children: _jsxs("div", __assign({ className: 'grid h-full min-h-0 grid-cols-12 gap-4' }, { children: [_jsx("section", __assign({ className: 'col-span-12 min-h-0 lg:col-span-3' }, { children: _jsx(LeftSidebar, { selectedPackageKey: selectedPackageKey, selectedContainerKey: selectedContainerKey, virtualPackages: virtualPackages, virtualContainers: virtualContainers, containerList: shipmentContainerList, containerLinkedPackageSeqIds: containerLinkedPackageSeqIds, onPackageSelect: handleSidebarPackageSelect, onContainerSelect: handleSidebarContainerSelect, onNewPackage: handleNewPackage, onNewContainer: function (containerTypeEnumId) {
                                    var tempId = "virtual-container-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8);
                                    var maxDisplay = virtualContainers.reduce(function (max, vc) { return Math.max(max, vc.displayNumber); }, 0);
                                    setVirtualContainers(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ tempId: tempId, displayNumber: maxDisplay + 1, containerTypeEnumId: containerTypeEnumId || 'CtPallet' }], false); });
                                    setSelectedContainerRef({ kind: 'virtual', tempId: tempId });
                                    setSelectedPackageRef(null);
                                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                                }, onBulkPackClick: function () { return setBulkPackModalVisible(true); }, onBulkContainerClick: function () { return setBulkContainerModalVisible(true); }, onBulkPack: function (containerId) {
                                    setSelectedContainerRef({ kind: 'real', containerId: containerId });
                                    setSelectedPackageRef(null);
                                    setBulkContainerModalVisible(true);
                                }, onContainerClose: function (containerId) { return setCloseContainerModalContainerId(containerId); }, onContainerReopen: handleReopenContainer, onContainerDelete: function (containerId) {
                                    handleDeleteContainer(containerId);
                                    if ((selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.kind) === 'real' && selectedContainerRef.containerId === containerId) {
                                        setSelectedContainerRef(null);
                                    }
                                }, onContainerReset: handleResetContainer, onAddChildContainer: function (parentContainerId, containerTypeEnumId) {
                                    var tempId = "virtual-child-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8);
                                    var maxDisplay = virtualContainers.reduce(function (max, vc) { return Math.max(max, vc.displayNumber); }, 0);
                                    setVirtualContainers(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                                        { tempId: tempId, displayNumber: maxDisplay + 1, parentContainerId: parentContainerId, containerTypeEnumId: containerTypeEnumId || 'CtCarton' }
                                    ], false); });
                                    setSelectedContainerRef({ kind: 'virtual', tempId: tempId });
                                    setSelectedPackageRef(null);
                                    setScanInputFocusSignal(function (prev) { return prev + 1; });
                                }, onDeleteVirtualPackage: function (tempId) {
                                    setVirtualPackages(function (prev) { return prev.filter(function (vp) { return vp.tempId !== tempId; }); });
                                    if ((selectedPackageRef === null || selectedPackageRef === void 0 ? void 0 : selectedPackageRef.kind) === 'virtual' && selectedPackageRef.tempId === tempId) {
                                        setSelectedPackageRef(null);
                                    }
                                }, onDeleteVirtualContainer: function (tempId) {
                                    setVirtualContainers(function (prev) { return prev.filter(function (vc) { return vc.tempId !== tempId; }); });
                                    if ((selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.kind) === 'virtual' && selectedContainerRef.tempId === tempId) {
                                        setSelectedContainerRef(null);
                                    }
                                }, showResetAllPackages: showResetAllPackages, showDeleteAllPackages: showDeleteAllPackages, isResetAllPackagesLoading: loading.resetAllPackages, isDeleteAllPackagesLoading: loading.deleteAllPackages, onResetAllPackages: handleResetAllPackagesAction, onDeleteAllPackages: handleDeleteAllPackagesAction }, void 0) }), void 0), _jsxs("section", __assign({ className: 'col-span-12 flex min-h-0 flex-col gap-4 lg:col-span-6' }, { children: [_jsxs("div", __assign({ className: 'flex-1 overflow-y-auto' }, { children: [(selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.kind) === 'real' && (function () {
                                            var _a, _b;
                                            var selectedContainer = shipmentContainerList.find(function (c) { return c.containerId === selectedContainerRef.containerId; });
                                            if (selectedContainer) {
                                                var linkedSeqId_1 = selectedContainer.shipmentPackageSeqId;
                                                var linkedPkgInfo = linkedSeqId_1 ? getPackageInfo(linkedSeqId_1) : null;
                                                var linkedRouteSegment = linkedSeqId_1
                                                    ? packageRouteSegments.find(function (r) { return r.shipmentPackageSeqId === linkedSeqId_1; }) || null
                                                    : null;
                                                var hasGateway = Boolean((shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shippingGatewayConfigId) || ((_a = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _a === void 0 ? void 0 : _a.shippingGatewayConfigId));
                                                var routeSegSeqId_1 = (_b = shipmentRouteSegments === null || shipmentRouteSegments === void 0 ? void 0 : shipmentRouteSegments[0]) === null || _b === void 0 ? void 0 : _b.shipmentRouteSegmentSeqId;
                                                return (_jsx(ContainerPane, { container: selectedContainer, allContainers: shipmentContainerList, shipmentItemDetailList: shipmentItemDetailList || [], productSkuUpcList: productSkuUpcList, isLoading: loading.containerScan, scanInputFocusSignal: scanInputFocusSignal, containerTypeMap: containerTypeMap, onSelectContainer: handlePaneContainerSelect, onScanToPack: handleScanToPack, onBulkPackIntoContainer: handleBulkPackIntoContainer, onContainerClose: function (containerId) { return setCloseContainerModalContainerId(containerId); }, onContainerReopen: handleReopenContainer, onContainerDelete: function (containerId) {
                                                        handleDeleteContainer(containerId);
                                                        setSelectedContainerRef(null);
                                                    }, onContainerReset: handleResetContainer, onContainerResetAndReturn: function (containerId) {
                                                        handleResetAndReturnContainer(containerId);
                                                        setSelectedContainerRef(null);
                                                    }, onAddChildContainer: function (parentContainerId) {
                                                        var tempId = "virtual-child-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8);
                                                        var maxDisplay = virtualContainers.reduce(function (max, vc) { return Math.max(max, vc.displayNumber); }, 0);
                                                        setVirtualContainers(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                                                            { tempId: tempId, displayNumber: maxDisplay + 1, parentContainerId: parentContainerId, containerTypeEnumId: 'CtCarton' }
                                                        ], false); });
                                                        setSelectedContainerRef({ kind: 'virtual', tempId: tempId });
                                                        setSelectedPackageRef(null);
                                                        setScanInputFocusSignal(function (prev) { return prev + 1; });
                                                    }, onUpdateContainerType: handleUpdateContainerType, containerTypeList: containerTypeList.map(function (ct) { return ({ enumId: ct.enumId, description: ct.description }); }), 
                                                    // Package-level props for closed containers
                                                    linkedPackageInfo: linkedPkgInfo ? {
                                                        isClosed: linkedPkgInfo.isClosed,
                                                        shipmentBoxTypeId: linkedPkgInfo.shipmentBoxTypeId,
                                                        boxTypeDescription: linkedPkgInfo.boxTypeDescription,
                                                        weight: linkedPkgInfo.weight,
                                                        weightUomId: linkedPkgInfo.weightUomId,
                                                        trackingNumber: linkedPkgInfo.trackingNumber
                                                    } : null, productStoreId: productStoreId, canPrintMainLabel: Boolean(linkedSeqId_1 && routeSegSeqId_1 &&
                                                        !(linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.trackingCode) &&
                                                        (linkedPkgInfo === null || linkedPkgInfo === void 0 ? void 0 : linkedPkgInfo.shipmentBoxTypeId) &&
                                                        hasGateway), canPrintCarton: Boolean(productStoreId) && spsCartonLabel, canGetMainLabel: Boolean(linkedSeqId_1 &&
                                                        !(linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.trackingCode) &&
                                                        !(linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.gatewayLabelId) &&
                                                        (linkedPkgInfo === null || linkedPkgInfo === void 0 ? void 0 : linkedPkgInfo.shipmentBoxTypeId) &&
                                                        hasGateway), canDownloadMainLabel: Boolean(linkedSeqId_1 &&
                                                        ((linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.gatewayLabelId) || (linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.labelImage) || (linkedRouteSegment === null || linkedRouteSegment === void 0 ? void 0 : linkedRouteSegment.labelUrl))), onPrintPackingSlip: function (seqId) {
                                                        void printPackingSlip(seqId);
                                                    }, onPrintContainerInsert: function (seqId) {
                                                        void printContainerInsert(seqId);
                                                    }, onPrintMainLabel: function (seqId) {
                                                        void printMainLabel(seqId);
                                                    }, onPrintCartonLabel: function (storeId) {
                                                        void printCartonLabel(storeId);
                                                    }, onGetMainLabel: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0:
                                                                    if (!linkedSeqId_1 || !routeSegSeqId_1)
                                                                        return [2 /*return*/];
                                                                    return [4 /*yield*/, handleGetMainLabel({ shipmentPackageSeqId: linkedSeqId_1, shipmentRouteSegmentSeqId: routeSegSeqId_1 })];
                                                                case 1:
                                                                    _a.sent();
                                                                    return [2 /*return*/];
                                                            }
                                                        });
                                                    }); }, onDownloadMainLabel: function () {
                                                        if (!shipmentId || !linkedSeqId_1 || !routeSegSeqId_1)
                                                            return;
                                                        var url = process.env.REACT_APP_API_BASE_URL + "/rest/s1/handheld/pack/shipment/" + shipmentId + "/label?shipmentRouteSegmentSeqId=" + routeSegSeqId_1 + "&shipmentPackageSeqId=" + linkedSeqId_1;
                                                        window.open(url, '_blank');
                                                    }, onOpenReturnLabelModal: function () {
                                                        if (linkedSeqId_1)
                                                            setReturnLabelModalVisible(true);
                                                    }, onOpenUpdatePackage: function () {
                                                        if (linkedSeqId_1)
                                                            setUpdatePackageModalVisible(true);
                                                    }, onPrintContainerLicensePlate: function () {
                                                        var url = getLabelUrl('containerLabel', undefined, selectedContainer.containerId);
                                                        downloadLabel(url);
                                                    } }, void 0));
                                            }
                                            return null;
                                        })(), (selectedContainerRef === null || selectedContainerRef === void 0 ? void 0 : selectedContainerRef.kind) === 'virtual' && (function () {
                                            var vc = virtualContainers.find(function (v) { return v.tempId === selectedContainerRef.tempId; });
                                            if (!vc)
                                                return null;
                                            var stubContainer = {
                                                shipmentId: shipmentId || '',
                                                containerId: "new-" + vc.tempId,
                                                statusId: 'ScpOpen',
                                                containerTypeEnumId: vc.containerTypeEnumId,
                                                isRoot: !vc.parentContainerId,
                                                childContainerIdList: [],
                                                contentSummaryList: [],
                                                totalQuantity: 0
                                            };
                                            var typeName = containerTypeMap.get(vc.containerTypeEnumId || 'CtPallet') || (vc.parentContainerId ? 'Carton' : 'Container');
                                            var vcDisplayLabel = "New " + typeName + " " + vc.displayNumber;
                                            var handleCreateVirtual = function () { return __awaiter(void 0, void 0, void 0, function () {
                                                var result, _a;
                                                return __generator(this, function (_b) {
                                                    switch (_b.label) {
                                                        case 0:
                                                            if (!vc.containerTypeEnumId)
                                                                return [2 /*return*/];
                                                            _b.label = 1;
                                                        case 1:
                                                            _b.trys.push([1, 3, , 4]);
                                                            return [4 /*yield*/, handleCreateContainer({
                                                                    containerTypeEnumId: vc.containerTypeEnumId,
                                                                    parentContainerId: vc.parentContainerId
                                                                })];
                                                        case 2:
                                                            result = _b.sent();
                                                            if (result === null || result === void 0 ? void 0 : result.containerId) {
                                                                // Materialize: drop the virtual placeholder and select the real container
                                                                setVirtualContainers(function (prev) {
                                                                    return prev.filter(function (v) { return v.tempId !== vc.tempId; });
                                                                });
                                                                setSelectedContainerRef({ kind: 'real', containerId: result.containerId });
                                                            }
                                                            return [3 /*break*/, 4];
                                                        case 3:
                                                            _a = _b.sent();
                                                            return [3 /*break*/, 4];
                                                        case 4: return [2 /*return*/];
                                                    }
                                                });
                                            }); };
                                            return (_jsx(ContainerPane, { container: stubContainer, allContainers: shipmentContainerList, shipmentItemDetailList: shipmentItemDetailList || [], productSkuUpcList: productSkuUpcList, isLoading: loading.containerScan, scanInputFocusSignal: scanInputFocusSignal, containerTypeMap: containerTypeMap, onScanToPack: handleScanToPack, displayLabel: vcDisplayLabel, isVirtual: true, isCreatingContainer: loading.containerCreate, onContainerCreate: handleCreateVirtual }, void 0));
                                        })(), !selectedContainerRef && selectedPackageRef && (_jsx(PackingPane, { selectedPackageRef: selectedPackageRef, selectedPackageSeqId: selectedPackageSeqId, selectedVirtualPackage: selectedVirtualPackage, selectedPackageInfo: selectedPackageInfo, packageContentBySeqId: packageContentBySeqId, packageOrderItemsBySeqId: packageOrderItemsBySeqId, packageSerialNumbersBySeqId: packageSerialNumbersBySeqId, itemAssets: itemAssets, boxTypes: boxTypes, resettingPackage: resettingPackage, isPackingItemLoading: loading.packItem, isPackageContentActionLoading: loading.packItem || loading.shipment, isDeletingPackage: loading.deletePackage, scanInputFocusSignal: scanInputFocusSignal, spsCartonLabel: spsCartonLabel, productStoreId: productStoreId, onScanToPack: handleScanToPack, onAdvanceToClose: handleAdvanceToClose, onOpenUpdatePackage: handleOpenUpdatePackage, onResetSelectedPackage: handleResetSelectedPackage, onDeleteSelectedPackage: handleDeleteSelectedPackageAction, onPrintPackingSlip: printPackingSlip, onPrintMainLabel: printMainLabel, onPrintCartonLabel: printCartonLabel, canGetMainLabel: canGetMainLabel, canDownloadMainLabel: canDownloadMainLabel, canRequestReturnLabel: canRequestReturnLabel, canUseReturnLabel: canUseReturnLabel, canRefundLabel: canRefundLabel, onGetMainLabel: handleGetMainLabelForSelectedPackage, onDownloadMainLabel: handleDownloadMainLabel, onOpenReturnLabelModal: handleOpenReturnLabelModal, onDownloadReturnLabel: handleDownloadReturnLabel, onPrintReturnLabel: handlePrintReturnLabel, onRefundLabel: handleRefundLabelForSelectedPackage, onUnpackPackageItem: handleUnpackPackageItem, onUpdatePackageItemQuantity: handleUpdatePackageItemQuantity }, void 0)), !selectedContainerRef && !selectedPackageRef && (_jsx(ScanToPackView, { isPackingItemLoading: loading.packItem, scanInputFocusSignal: scanInputFocusSignal, onScanToPack: handleScanToPack }, void 0))] }), void 0), showAssemblyTaskPane && (_jsxs("div", __assign({ className: 'rounded-2xl border border-gray-200 bg-white shadow-sm' }, { children: [_jsxs("button", __assign({ type: 'button', onClick: function () { return setIsAssemblyCollapsed(function (prev) { return !prev; }); }, className: 'flex w-full items-center justify-between rounded-2xl px-4 py-3 text-left' }, { children: [_jsx("span", __assign({ className: 'font-bold uppercase text-gray-600', style: { fontSize: 11, letterSpacing: '0.08em' } }, { children: t('Assembly Task') }), void 0), _jsxs("div", __assign({ className: 'flex items-center gap-2 text-xs font-semibold text-gray-500' }, { children: [_jsx("span", { children: isAssemblyCollapsed ? t('Expand') : t('Collapse') }, void 0), _jsx(CaretDownOutlined, { style: { fontSize: 12 }, className: "transition-transform " + (isAssemblyCollapsed ? '-rotate-90' : '') }, void 0)] }), void 0)] }), void 0), !isAssemblyCollapsed && (_jsx("div", __assign({ className: 'px-3 pb-3' }, { children: _jsx(ShipmentAssemblyTaskPane, {}, void 0) }), void 0))] }), void 0))] }), void 0), _jsxs("section", __assign({ className: 'col-span-12 flex min-h-0 flex-col gap-4 lg:col-span-3' }, { children: [_jsx("div", __assign({ className: 'min-h-0 flex-1' }, { children: _jsx(RightSidebar, { onShowAddressModal: function () { return setAddressModalVisible(true); } }, void 0) }), void 0), _jsx(PackingManagerActions, { onShowCancelModal: function () { return setCancelModalVisible(true); }, onShowPackCompleteModal: function () { return setPackCompleteModalVisible(true); } }, void 0)] }), void 0)] }), void 0) }), void 0), _jsx(PrinterModal, { visible: printerModalVisible, onClose: function () { return setPrinterModalVisible(false); } }, void 0), _jsx(UpdateAddressModal, { visible: addressModalVisible, onClose: function () { return setAddressModalVisible(false); } }, void 0), _jsx(PackCompleteModal, { visible: packCompleteModalVisible, onClose: function () { return setPackCompleteModalVisible(false); } }, void 0), _jsx(UpdatePackageModal, { visible: !!(selectedPackageSeqId || activeContainerLinkedSeqId) && updatePackageModalVisible, packageSeqId: selectedPackageSeqId || activeContainerLinkedSeqId, onClose: function () { return setUpdatePackageModalVisible(false); } }, void 0), _jsx(ClosePackageModal, { visible: !!selectedPackageSeqId && isCloseModalVisible, packageSeqId: selectedPackageSeqId, onClose: function () { return setIsCloseModalVisible(false); }, onClosed: handlePackageClosed }, void 0), _jsx(CloseContainerModal, { visible: !!closeContainerModalContainerId, containerId: closeContainerModalContainerId, onClose: function () { return setCloseContainerModalContainerId(null); }, onClosed: function () { return setCloseContainerModalContainerId(null); } }, void 0), _jsx(BulkPackModal, { ref: bulkPackModalRef, visible: bulkPackModalVisible, boxTypes: boxTypes, loading: loading.packItem || loading.closePackage, onClose: function () { return setBulkPackModalVisible(false); }, onSubmit: handleBulkPackSubmit }, void 0), _jsx(BulkContainerModal, { ref: bulkContainerModalRef, visible: bulkContainerModalVisible, loading: loading.containerScan, selectedContainerId: selectedRealContainerId, containerTypeList: containerTypeList.map(function (ct) { return ({ key: ct.enumId, value: ct.description }); }), onClose: function () { return setBulkContainerModalVisible(false); }, onSubmit: function (params) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, handleBulkCreateContainers(params)];
                            case 1:
                                _a.sent();
                                setBulkContainerModalVisible(false);
                                return [2 /*return*/];
                        }
                    });
                }); } }, void 0), _jsx(SerialNumberModal, { visible: serialNumberModalVisible, onClose: function () {
                    setSerialNumberModalVisible(false);
                    setPendingSerializedPackRequest(null);
                    setPendingScanId(null);
                }, productId: pendingScanId, onSubmit: handleSerialNumberSubmit }, void 0), _jsx(ReturnLabelModal, { visible: !!selectedPackageSeqId && returnLabelModalVisible, onClose: function () { return setReturnLabelModalVisible(false); }, packageSeqId: selectedPackageSeqId }, void 0), shipmentId && (_jsx(CancelShipmentModal, { visible: cancelModalVisible, onClose: function () { return setCancelModalVisible(false); }, onConfirm: handleConfirmCancel, shipmentId: shipmentId }, void 0))] }), void 0));
};
export default PackingManager;
